import React, { ReactElement } from 'react'
import { Chip } from '@mui/material'

import {
  AccreditationHealthStatus,
  AccreditationPendingStatus,
} from 'src/v3/content-pipeline/accreditation-health.slice'
import {
  PENDING_META,
  STATUS_META,
} from 'src/v3/content-pipeline/accreditation/utils/accreditation-status-meta'

export function AccreditationStatusChip({
  status,
  variant = 'outlined',
}: {
  status: AccreditationHealthStatus
  variant?: 'outlined' | 'filled'
}): ReactElement {
  let meta = STATUS_META[status]
  return (
    <Chip
      size="small"
      label={meta.label}
      color={meta.color === 'default' ? undefined : meta.color}
      variant={variant}
    />
  )
}

export function AccreditationPendingChip({
  pending,
}: {
  pending: AccreditationPendingStatus
}): ReactElement {
  let meta = PENDING_META[pending]
  return (
    <Chip
      size="small"
      label={meta.label}
      color={meta.color === 'default' ? undefined : meta.color}
    />
  )
}
